<template>
<b-form autocomplete="new-password">
  <b-form-group label="権限">
    <b-form-select v-model="item.level" :options="$store.state.data.info.auth"></b-form-select>
    <base-error-feedback :errors="errors.level"></base-error-feedback>
  </b-form-group>
  <b-form-group label="メール">
    <b-form-input v-model="item.email" type="email"></b-form-input>
    <base-error-feedback :errors="errors.email"></base-error-feedback>
  </b-form-group>
  <b-form-group label="名前">
    <b-form-input v-model="item.name" type="text"></b-form-input>
    <base-error-feedback :errors="errors.name"></base-error-feedback>
  </b-form-group>
  <b-form-group label="パスワード">
    <b-form-input v-model="item.password" type="password" autocomplete="new-password"></b-form-input>
    <base-error-feedback :errors="errors.password"></base-error-feedback>
  </b-form-group>
  <b-form-group class="mt-4 text-right">
    <b-link class="text-danger mr-3" @click="onClickDelete($event, item)">削除</b-link>
    <b-button variant="light" @click="onClickSave($event, item)">保存</b-button>
  </b-form-group>
</b-form>
</template>

<script>
export default {
  props: [ 'model' ],
  data () {
    return {
      errors: {},
      item: this.model,
    }
  },
  methods: {
    onInit () {
      if (!this.item.id) {
        this.item = { level: '100', }
      }
    },
    onClickSave (e, item) {
      this.errors = []
      this.$store.dispatch(
        'dataUserUpdate',
        item
      ).then((response) => {
        this.onInit()
        this.$store.dispatch('uiToggleDetailUserAdd', false)
        this.$store.dispatch('uiPushFlash', { variant: 'success', text: '保存しました。', })
      }).catch(error => {
        this.errors = error.response.data.errors
      })
    },
    onClickDelete (e, item) {
      if (!item.id) {
        this.$store.dispatch('uiToggleDetailUserAdd', false)
        return
      }
      if (!confirm('本当に削除しますか？')) {
        return
      }
      this.$store.dispatch(
        'dataUserRemove',
        item
      ).then((response) => {
        this.$store.dispatch('uiPushFlash', { variant: 'success', text: '削除しました。', })
      })
    },
  },
  mounted () {
    this.onInit()
  },
}
</script>

<style lang="scss">
</style>
